import Dexie, { EntityTable } from 'dexie';

export interface MenuOption {
  optionId: string;
  title: string;
  desc: string;
  price: number;
  rank: number;
}

export const db = new Dexie('menuOptions') as Dexie & {
  menuOptions: EntityTable<MenuOption, 'optionId'>;
};

db.version(1).stores({ menuOptions: 'optionId' });

// db.menuOptions.bulkPut([
//   {
//     optionId: 'abc',
//     title: 'Duck for sale',
//     desc: 'Never been worn',
//     price: 46,
//     rank: 1,
//   },
//   {
//     optionId: 'def',
//     title: 'Cat for sale',
//     desc: 'Never been shorn',
//     price: 14,
//     rank: 2,
//   },
// ]);
